<div id="quiz-wrapper" class="wrapper w-100 h-100" (mouseup)="onPressUp()" (touchend)="onPressUp()" (press)="onPress()" (pressup)="onPressUp()" (click)="changeIntervalState($event)">
  <div class="question-wrapper h-100">

    <!-- Bars -->
    <div class="bar-container">
      <div class="bar" *ngFor="let question of questions; let i=index;" [class.d-none]="question?.info">
        <mat-progress-bar
        [color]="'#01bfbd'"
        [mode]="'determinate'"
        [bufferValue]="0"
        [value]="getValue(i)"
        ></mat-progress-bar>
      </div>
    </div>

    <!-- Question header -->
    <div *ngIf="!questions[currentQuestionIndex]?.info" class="d-flex question-header">
      <div class="question-title">Question
        <span class="current-question-number"> {{questions[currentQuestionIndex].srNo}}</span><span class="out-of"> of {{questions[questions.length-1].srNo}}</span>
      </div>
      <div class="flex-fill text-right"><i class="icon-kettobirds"></i></div>
    </div>

    <div *ngIf="questions[currentQuestionIndex]?.info" class="answer-info-header">
      <div *ngIf="currentQuestionIndex !== questions.length - 1" class="text">Keep going!</div>
      <div *ngIf="currentQuestionIndex === questions.length - 1" class="text">You did it!</div>
    </div>


    <!-- Question -->
    <div *ngIf="!questions[currentQuestionIndex].info" class="question-container">

      <div class="question" *ngIf="questions[currentQuestionIndex].question">
        {{questions[currentQuestionIndex].question}}
      </div>

      <div class="option" *ngFor="let option of questions[currentQuestionIndex].options">
        <button type="button" class="{{checkAnswer(option)}}" mat-raised-button (click)="onOptionSelect(option.option, option.isCorrect)">{{option.option}}</button>
      </div>
    </div>

    <!-- Info about question -->
    <div *ngIf="questions[currentQuestionIndex].info && currentQuestionIndex !== questions.length - 1" class="question-info-section">
      <div class="info-header">
        <div class="info-image">
          <img *ngIf="isCorrect" class="correct" loading="lazy" src="assets/images/sip/kids-1.png" />
          <img *ngIf="!isCorrect" class="incorrect" loading="lazy" src="assets/images/sip/kids.png" />
        </div>
        <div *ngIf="!isCorrect" class="incorrect-exp">
          <img loading="lazy" src="assets/images/emoji/sad.png" />
          <span>Don’t Worry!</span>
        </div>
        <div *ngIf="!isCorrect" class="info-header-subtitle incorrect"><strong class="prize">+ <app-currency-icon [currency]="order?.iso_currency"></app-currency-icon>100<!--{{prizeAmount/questions.length|number : '1.0-0'}}--></strong> will still be added to your contribution</div>
        <div *ngIf="isCorrect" class="info-header-subtitle correct"><strong class="prize">+ <app-currency-icon [currency]="order?.iso_currency"></app-currency-icon>100</strong> Added to Impact</div>
        <div *ngIf="isCorrect" class="correct-exp">
          <img loading="lazy" src="assets/images/emoji/party.png" />
          <span>Well Done!</span>
        </div>
      </div>
      <div class="info">
        {{questions[currentQuestionIndex].info}}
      </div>
    </div>

    <!-- Info about question last -->
    <div *ngIf="questions[currentQuestionIndex].info && currentQuestionIndex == questions.length - 1" class="question-info-section last">
      <div class="info-header">
        <div class="info-image">
          <img loading="lazy" src="assets/images/sip/kids.png" />
        </div>
        <div class="last-info">
          <div class="icon"><mat-icon>info</mat-icon></div>
          <div class="text">Claim the additional <strong><app-currency-icon [currency]="order?.iso_currency"></app-currency-icon>{{prizeAmount}}</strong> by signing up for the Social Impact Plan.</div>
        </div>
        <div class="incorrect-exp"><span>Great!</span></div>
      </div>
      <div class="info">Ketto’s Social Impact Plan lets you make automatic monthly contributions</div>
    </div>

    <!-- Info footer -->
    <div class="info-footer" *ngIf="questions[currentQuestionIndex].info && currentQuestionIndex == 1">
      <i class="icon-manual-click"></i>
      <div class="tap">Tap anywhere to continue</div>
    </div>

    <!-- Redeem section -->
    <div class="redeem-section" *ngIf="currentQuestionIndex === questions.length - 1">
      <button [routerLink]="['/new/sip/welcome']" [queryParams]="{amt: paymentV2.getMinSipAmount(order?.iso_currency)?.amount, currency: order?.iso_currency}" queryParamsHandling="merge" (click)="onPaymentClick()" mat-raised-button>
        <span *ngIf="!vars.isOrderLoading">Redeem & Sign Up</span>
        <span *ngIf="vars.isOrderLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></span>
      </button>
      <div class="redeem-skip" (click)="redeemPrizeAmount()">Skip</div>
    </div>
  </div>
</div>

<!-- Gesture intro overlay -->
<app-gesture-intro-overlay *ngIf="showGestureOverlay" (click)="startQuiz()" />
